import type { ArdoqId } from '@ardoq/api-types';
import {
  type FeatureContext,
  Features,
  featureOperations,
} from '@ardoq/features';

type Lock = ArdoqId | null | undefined;

const isLockingEnabled = (featureContext: FeatureContext): boolean =>
  featureOperations.hasFeature(featureContext, Features.LOCKED_COMPONENTS);

const isLocked = (lock: Lock, featureContext: FeatureContext): boolean =>
  Boolean(lock) && isLockingEnabled(featureContext);

const isAnyLocked = (locks: Lock[], featureContext: FeatureContext): boolean =>
  locks.some(lock => isLocked(lock, featureContext));

const effectiveLock = (
  lock: Lock,
  featureContext: FeatureContext
): ArdoqId | null => (lock && isLockingEnabled(featureContext) ? lock : null);

export const lockOperations = {
  isLockingEnabled,
  isLocked,
  isAnyLocked,
  effectiveLock,
};
